module.exports = __webpack_public_path__ + "img/c5.c1591497.png";